/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    getDPIADataFlow() {
        return HttpService.get(environment.API_DPIA_DATAFLOW);
    },
    getDPIAIdentification() {
        return HttpService.get(environment.API_DPIA_IDENTIFICATION);
    },
    getDPIAImpact() {
        return HttpService.get(environment.API_DPIA_IMPACT);
    },
    createdDPIAImpact(payload) {
        return HttpService.post(environment.API_DPIA_IMPACT, payload);
    },
    updateDPIAImpact(payload) {
        return HttpService.put(environment.API_DPIA_IMPACT, payload);
    },
    deleteDPIAImpact(id) {
        return HttpService.delete(
            environment.API_DPIA + '/impact-organize/' + id
        );
    },
    getDPIAMeasures() {
        return HttpService.get(environment.API_DPIA_MEASURES);
    },
    createdDPIAMeasures(payload) {
        return HttpService.post(environment.API_DPIA_MEASURES, payload);
    },
    updateDPIAMeasures(payload) {
        return HttpService.put(environment.API_DPIA_MEASURES, payload);
    },
    deleteDPIAMeasures(id) {
        return HttpService.delete(
            environment.API_DPIA + '/measures-organize/' + id
        );
    },
    createDPIA(payload) {
        return HttpService.post(environment.API_DPIA, payload);
    },
    updateDPIA(payload) {
        return HttpService.put(environment.API_DPIA, payload);
    },
    getDPIA(id) {
        return HttpService.get(environment.API_DPIA + '/' + id);
    },
    getDPIAList(params) {
        return HttpService.get(environment.API_DPIA, {
            params,
        });
    },
    getHitoryByID(params) {
        return HttpService.get(environment.API_DPIA + '/history', {
            params,
        });
    },
    getHistoryDetail(id) {
        return HttpService.get(environment.API_DPIA + '/history/' + id);
    },
    deleteDPIA(id) {
        return HttpService.delete(environment.API_DPIA + '/' + id);
    },
};
